import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL e Anon Key são obrigatórios');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Reduz tentativas de refresh para evitar spam de erros de rede
    storageKey: 'meucontrole-auth',
  },
  global: {
    fetch: (url, options) => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000); // 15s timeout
      return fetch(url, { ...options, signal: controller.signal })
        .catch((err) => {
          // Silencia erros de rede para não poluir o console
          if (err.name === 'AbortError' || err.message === 'Failed to fetch') {
            return new Response(JSON.stringify({ error: 'network_error' }), {
              status: 503,
              headers: { 'Content-Type': 'application/json' },
            });
          }
          throw err;
        })
        .finally(() => clearTimeout(timeout));
    },
  },
});
